export enum EFileType {
  Picture = 1,
  Sound = 2,
  Log = 3,
}

export enum EPrivacySetting {
  Public = 1,
  Private = 2,
  Unlisted = 3,
}
export interface IPostBatchPresignedUploadUrlReq {
  user_id: number;
  file_suffix: string;
  folder_name: string;
  file_type?: EFileType;
  count: number;
  privacy_setting: EPrivacySetting;
}

export interface IPostBatchPresignedUploadUrlResp {
  upload_list: {
    upload_url: string;
    real_file_name: string;
    cdn_url: string;
  }[];
}
